import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyContactBar from './components/StickyContactBar';
import RecentBookingNotification from './components/RecentBookingNotification';
import PageTracker from './components/PageTracker';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Pricing from './pages/Pricing';
import Samples from './pages/Samples';
import ContactUs from './pages/ContactUs';
import VernacularPage from './pages/VernacularPage';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';

// Initialize Google Analytics
// REPLACE 'G-XXXXXXXXXX' with your actual Measurement ID from Google Analytics
ReactGA.initialize('G-X8RCWDRT75');

function App() {
  return (
    <Router>
      <PageTracker />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/samples" element={<Samples />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/ads/:language" element={<VernacularPage />} />
          </Routes>
        </main>
        <Footer />
        <StickyContactBar />
        <RecentBookingNotification />
      </div>
    </Router>
  );
}

export default App;
